import React, { useEffect, useState, useCallback } from 'react';
import { api } from '../../lib/api';
import { History, RefreshCw, ChevronDown, ChevronUp } from 'lucide-react';
import { NoteGrid, fmtDT, REASON_LABEL } from './NoteGrid';

export const HistoryCard = ({ refreshKey }) => {
  const [frames, setFrames] = useState([]);
  const [open, setOpen] = useState(null);
  const [expanded, setExpanded] = useState(false);
  const load = useCallback(() => api.vbManagerLog(100).then(r => setFrames(r.data.frames || [])).catch(() => {}), []);
  useEffect(() => { load(); }, [load, refreshKey]);
  const shown = expanded ? frames : frames.slice(0, 10);
  return (
    <div className="bg-card border border-border rounded-sm p-5" data-testid="vb-history">
      <div className="flex items-center justify-between gap-2">
        <p className="text-sm font-medium text-foreground flex items-center gap-2"><History className="w-4 h-4 text-muted-foreground" /> Historie <span className="text-[10px] text-muted-foreground font-normal">letzte {frames.length} gesendete Frames</span></p>
        <button onClick={load} className="text-muted-foreground hover:text-foreground" data-testid="vb-history-reload"><RefreshCw className="w-3.5 h-3.5" /></button>
      </div>
      <div className="mt-2 divide-y divide-border/50">
        {shown.length === 0 && <p className="text-xs text-muted-foreground py-2">Noch nichts gesendet.</p>}
        {shown.map(f => (
          <div key={f.id} data-testid={`vb-history-${f.id}`}>
            <button onClick={() => setOpen(open === f.id ? null : f.id)} className="w-full flex items-center justify-between gap-2 py-1.5 text-left">
              <span className="text-xs text-foreground truncate">
                <span className="font-mono text-muted-foreground mr-2">{fmtDT(f.at)}</span>{f.board_name}
                <span className="text-muted-foreground"> · {REASON_LABEL[f.reason] || f.reason}{f.by ? ` · ${f.by}` : ''}</span>
                <span className="font-mono text-[10px] text-muted-foreground ml-2">{(f.lines || []).map(l => l.trim()).filter(Boolean).join(' | ')}</span>
              </span>
              <span className="flex items-center gap-1.5 shrink-0">
                {f.dry_run && <span className="text-[9px] font-mono px-1 rounded-sm border border-amber-500/40 text-amber-300">DRY</span>}
                {open === f.id ? <ChevronUp className="w-3 h-3 text-muted-foreground" /> : <ChevronDown className="w-3 h-3 text-muted-foreground" />}
              </span>
            </button>
            {open === f.id && <div className="pb-2 pl-2"><NoteGrid matrix={f.matrix} size="sm" /></div>}
          </div>
        ))}
      </div>
      {frames.length > 10 && (
        <button onClick={() => setExpanded(e => !e)} className="mt-2 text-[11px] text-muted-foreground hover:text-foreground" data-testid="vb-history-toggle">{expanded ? 'Weniger' : `Alle ${frames.length} anzeigen`}</button>
      )}
    </div>
  );
};
